import React, { useEffect, useState, FC } from "react";
import { Button, message, Select, Input, Tooltip } from "antd";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBox/Types";
import useNavModel from "@/model/navModel";
import { repairFormatNum, formatNum } from "@/utils/utils"
import { useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { globalPrompt } from "@/components/message";
import { ITopType } from "@/types/ScmTypes";
import { DetailType, IServiceNatureCodeType, IPriceTypeEnum } from "@/types/ScmEnums";
import useGlobalModel, { getFindItem, transOptions, vehicleOption, getVehicleItem, getVinItem, vinOption } from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IVehicleFields } from "@/views/base/customerFiles/vehicle/vehicleType";
import { vehicleService } from "@/views/base/customerFiles/vehicle/vehicleService";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { debounce } from "lodash";
import { useMaintenanceModel } from "../../maintenanceModel";
import FontIcon from "@/components/YhIcon";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import { stockStatisticService } from "@/views/stock/statistic/stockStatisticService";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";

export const FormBox: FC<ITopType> = ({ id, mode, parentInfo, IFormRef }) => {
    const {
        setSelectedRowKeys,
        setDescRows,
        setSelectedRow
    } = useMaintenanceModel();
    const {
        addDesc,
        editDesc,
        detailAddForm,
        detailEditForm,
        detailLookForm,
        updateAddFormVal,
        updateEditFormVal,
        vehicleEditAll, setVehicleEditAll,
        vehicleAddAll, setVehicleAddAll,
        insertDetail,
        editDetail,
        resetAddCatch,
        resetEditCatch,
        getDetailEditOne,
        setTopButsControl,
        detailMaterialAddList, setDetailMaterialAddList,
        detailItemAddList, setDetailItemAddList,
        detailItemEditList, setDetailItemEditList,
        detailMaterialEditList, setDetailMaterialEditList,
        setConsumeHistoryModel, setConsumeHistoryVisible,
        setRepairHistoryModel,
        setRepairHistoryVisible,
        saveLoading, setSaveLoading
    } = useMaintenanceDetailsModel();
    const { getTreeNodeOne } = useDictModel();
    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { beShopDs, CustomerData, shopAndOrg: { shopId, shopCode, shopName }, getSettlementParty } = useGlobalModel();
    let { serviceNatureCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm
    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode === DetailType.edit) {
            resetEditCatch(mode)
            getDetailEditOne(id, mode)
        }
        mode === DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])

    useEffect(() => {
        return () => {
            // !findNav("7-4-1") && resetAddCatch(mode);
            !findNav("7-4-2") && resetEditCatch(mode);
        }
    }, [selectedNavId, shopCode])
    const { getSelectedDictOne } = useDictModel();
    const Options = [
        { label: "整单折扣", value: "1" },
        { label: "维修项目折扣", value: "2" },
        { label: "维修用料折扣", value: "3" }
    ]
    const onDiscount = () => {
        let discountNum: string = "1";
        let discountVal: string = "";

        globalPrompt("modal", {
            width: 380,
            title: "折扣",
            type: "info",
            // text: "",
            text: <>
                <span>请选择折扣类型</span>
                <Select
                    showSearch={true}
                    defaultValue="1"
                    options={Options}
                    onChange={(value) => discountNum = value}
                />
                <span>请输入折扣系数</span>
                <Input
                    onChange={(e) => { discountVal = e.target.value }}
                    suffix="%"
                />
            </>,
            okText: "确定",
            onOk: () => {
                var re = /^[0-9]+.?[0-9]*$/;
                return new Promise((resolve, reject) => {
                    if (!re.test(discountVal)) {
                        reject("输入的值不是数字，请重新输入")
                        message.error("输入的值不是数字，请重新输入")

                    } else {
                        resolve(discountVal)
                    }
                }).then(res => {
                    if (discountNum === "1") {
                        onDiscountItem(+discountVal);
                        onDiscountMaterial(+discountVal);
                    } else if (discountNum === "2") {
                        onDiscountItem(+discountVal);
                    } else if (discountNum === "3") {
                        onDiscountMaterial(+discountVal);
                    }
                })
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const onDiscountItem = (discount: number) => {
        let detailsItemList = mode === "add" ? detailItemAddList : detailItemEditList;
        let newDetailsItemList = detailsItemList.map((item) => {
            return {
                ...item,
                discountRate: discount,
                receivableAmount: +repairFormatNum(Number(item.itemAmount) * discount / 100),
            }
        })
        mode === "add" ? setDetailItemAddList(newDetailsItemList) : setDetailItemEditList(newDetailsItemList)
    }

    const onDiscountMaterial = (discount: number) => {
        let detailsMaterialList = mode === "add" ? detailMaterialAddList : detailMaterialEditList;
        let newDetailsMaterialList = detailsMaterialList.map((item) => {
            return {
                ...item,
                discountRate: discount,
                receivableAmount: +repairFormatNum(Number(item.materialAmount) * discount / 100),
            }
        })
        mode === "add" ? setDetailMaterialAddList(newDetailsMaterialList) : setDetailMaterialEditList(newDetailsMaterialList)
    }
    const save = () => {
        // if (!formComputeRule(mode)) return;
        let goodList = mode === "add" ? detailMaterialAddList : detailMaterialEditList;
        // 单价为0的数组
        let zeroList = goodList.filter(item => item.price == 0)
        let numAmount = 0;
        goodList.forEach((item) => {
            numAmount += item.decreaseAmount
        })
        // if (numAmount >= 1) {
        //     globalPrompt("message", { text: '单项优惠金额的总和不能大于1', type: "error" })
        //     return
        // }
        if (zeroList.length) {
            globalPrompt("message", { text: `【${zeroList.map(item => item.materialName).join()}】的价格不能为0`, type: "error" })
            return
        }
        IFormRef.current?.validateFields().then(async res => {
            if (res.settlementPartyCode === "settle-party.internal" && !!!res.note) {
                message.warning("结算方为部门内部费用时，备注为必填项，请补齐表单里的备注项");
                return false;
            }
            if (mode === "add") {
                // await insertSave(res)
                let { receivableAll } = addDesc;
                receivableAll = +repairFormatNum(receivableAll);
                let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailAddForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }

                // if (!(customerCode && customerName && payType && settlementPartyCode)) {
                //     message.warning("请补全客户名称或结算类型或结算方")
                //     return false
                // }
                let { accountName, availableAmount, isBill, accountCustomerName } = await getSettlementParty({ settlementPartyCode, customerName, customerCode, payType, settlementsettlementPartyParams: getTreeNodeOne(settlementPartyCode as string)[0], bentityCode });
                if (payType !== IVRMSettleTypeEnum.SETTLE_CASH) {
                    console.log(availableAmount)
                    console.log(receivableAll)
                    if (accountName && availableAmount >= receivableAll) {//有账户，但是额度大于开单金额的
                        savsTips(`当前${accountName},授信额度为${availableAmount}是否确认？？`, true, res)
                    } else if (accountName && availableAmount < receivableAll) { //有账户，但是额度低于开单金额的
                        savsTips(`当前${accountName},授信额度为${availableAmount}小于开单金额${receivableAll}，无法开单，是否确认？？`, false)
                    } else if (!accountName) { //查对应没有账户的
                        savsTips(`当前${accountCustomerName}，无对应账户，无法开单，是否确认？？`, false)
                    }
                } else {
                    await insertSave(res)
                }
            } else if (mode === "edit") {
                // let { id, maintenanceCode } = detailEditForm
                // const retData = await editDetail({ ...res, id, maintenanceCode })
                // if (retData) {
                //     globalPrompt("message", { text: "编辑成功", type: "success" });
                //     await getDetailEditOne(maintenanceCode as string, mode)
                // }
                let { receivableAll } = editDesc;
                let { id, maintenanceCode } = detailEditForm
                let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailEditForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }
                let { accountName, availableAmount, accountCustomerName } = await getSettlementParty({ settlementPartyCode, customerName, customerCode, payType, settlementsettlementPartyParams: getTreeNodeOne(settlementPartyCode as string)[0], bentityCode });
                if (payType !== IVRMSettleTypeEnum.SETTLE_CASH) {
                    if (accountName && availableAmount >= receivableAll) {//有账户，但是额度大于开单金额的
                        savsTips(`当前${accountName},授信额度为${availableAmount}是否确认？？`, true, { ...res, id, maintenanceCode })
                    } else if (accountName && availableAmount < receivableAll) { //有账户，但是额度低于开单金额的
                        savsTips(`当前${accountName},授信额度为${availableAmount}小于开单金额${receivableAll}，无法开单，是否确认？？`, false)
                    } else if (!accountName) { //查对应没有账户的
                        savsTips(`当前${accountCustomerName}，无对应账户，无法开单，是否确认？？`, false)
                    }
                } else {
                    const retData = await editDetail({ ...res, id, maintenanceCode })
                    globalPrompt("message", { text: "编辑成功", type: "success" });
                    if (retData) {
                        globalPrompt("message", { text: "编辑成功", type: "success" });
                        await getDetailEditOne(maintenanceCode as string, mode)
                    }
                }
            }
        })
    }
    const savsTips = (info: string, isSave: boolean, from: any = {}) => {
        globalPrompt("modal", {
            title: "维修单详情保存",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => {
                if (isSave) {
                    if (mode === "add") {
                        await insertSave(from)
                    } else if (mode === "edit") {
                        const retData = await editDetail(from)
                        if (retData) {
                            globalPrompt("message", { text: "编辑成功", type: "success" });
                            await getDetailEditOne(from.maintenanceCode as string, mode)
                        }
                    }
                }
            }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const insertSave = async (res: any) => {
        let { receivableAll } = addDesc
        if (receivableAll < 0) {
            globalPrompt("modal", {
                title: "维修单详情保存",
                type: "warning",
                text: "当前单据为负数金额，是否确认？？",
                okText: "确定",
                onOk: debounce(async () => { await saveResult(res) }, 500),
                cancelText: "取消",
                onCancel: () => { }
            })
        } else {
            await saveResult(res)
        }
    }
    const saveResult = async (res: any) => {
        const retData = await insertDetail(res) as any
        if (retData) {
            globalPrompt("message", { text: "新增成功", type: "success" });
            setSelectedRowKeys([retData?.id as string])
            setDescRows([retData])
            setSelectedRow(retData)
            resetAddCatch(mode)
            goBack();
        }
    }
    const goBack = () => {
        if (parentInfo) {
            replaceNav(selectedNavId, parentInfo.selectedNavId);
        } else {
            replaceNav(selectedNavId, "7-4")
        }
    }
    const onRefresh = () => {
        if (mode === "add") {
            IFormRef.current?.resetFields()
            getVehicleAllList()
            resetAddCatch()
        } else if (mode === "edit") {
            getDetailEditOne(id, mode)
        }
        message.success("刷新成功")
    }
    const isMaterialModel = () => {
        if (mode === "look") return false
        if (mode === "edit" && (detailEditForm.status === DictCodeEnmu.MAINTENANCE_COMPLETED || detailEditForm.status === DictCodeEnmu.MAINTENANCE_SETTLE || detailEditForm.status === "maintenance-status.paying")) {
            return false;
        }
        return true;
    }
    const rightChildren = <>
        {isMaterialModel() && <>
            <YhAuth resCode={ResourceAuthEnum.M_ED_DISCOUNT_ALL}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={onDiscount}
                >快捷折扣</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { save() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            </YhAuth>
        </>}
        {mode !== "look" && <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onRefresh}
        >刷新</Button>}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>
    //车辆类型
    const vehicleTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ vehicleTypeName: option.label, vehicleTypeCode: option.value });
    }
    //结算方
    const settlementPartyChange = (value: string, option: ISelectOption) => {
        option && onChange({ settlementPartyName: option.label, settlementPartyCode: option.value });
    }
    //结算方式
    // const paymentMethodChange = (value: string, option: ISelectOption) => {
    //     option && onChange({ paymentMethodName: option.label, paymentMethodCode: option.value });
    // }
    // //客户类型
    // const customerTypeChange = (value: string, option: ISelectOption) => {
    //     option && onChange({ customerTypeName: option.label, customerTypeCode: option.value });
    // }
    //发票类型
    const invoiceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ invoiceTypeName: option.label, invoiceTypeCode: option.value });
    }
    //销售实体
    const bentityChange = (value: string, option: ISelectOption) => {
        option && onChange({ bentityName: option.label, bentityCode: option.value });
    }
    //服务性质
    const serviceNatureChange = (value: string, option: ISelectOption) => {
        if (value) {
            //政策性索赔
            if (value === IServiceNatureCodeType.REPAIR_TYPE_POLICY_CLAIM) {
                option && onChange({ serviceNatureName: option.label, serviceNatureCode: option.value, priceTypeName: "采购成本价", priceTypeCode: "price-selection.pur-cost" });
            }
            //索赔服务 、索赔服务-J、保养合约
            else if (value === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || value === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || value === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN) {
                option && onChange({ serviceNatureName: option.label, serviceNatureCode: option.value, priceTypeName: undefined, priceTypeCode: undefined });
            }
            else {
                option && onChange({ serviceNatureName: option.label, serviceNatureCode: option.value, priceTypeName: "零售价", priceTypeCode: "price-selection.retail" });
            }

            alterListPrice(
                value === IServiceNatureCodeType.REPAIR_TYPE_POLICY_CLAIM ? "price-selection.pur-cost" :
                    (value === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || value === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || value === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN) ? undefined : "price-selection.retail",
                value, customerCode as string);
        } else {
            onChange({ serviceNatureName: undefined, serviceNatureCode: undefined, priceTypeName: undefined, priceTypeCode: undefined });
        }
    }
    //售价选择
    const priceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ priceTypeName: option.label, priceTypeCode: option.value });
        if (value) {
            alterListPrice(value, serviceNatureCode as string, customerCode as string);
        }
    }
    //from销售类型，售价选择时更改 详情表格的价格信息
    const alterListPrice = async (priceTypeCode: string | undefined, serviceNatureCode: string, customerCode: string) => {
        let detailsList = mode == "add" ? detailMaterialAddList : detailMaterialEditList;
        if (!detailsList.length) return;
        if (!serviceNatureCode || !customerCode) {
            message.warning("请补全客户名称，维修类型才可以，对下列表格的价格数据进行更改");
            return false;
        }
        let newDetailsList = await Promise.all(detailsList.map(async (item) => {
            let { stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, purchasePrice, decreaseAmount, retailPrice, num, ...params } = item as { latestPurPrice: number, decreaseAmount: number, lateSalePrice: number, purchasePrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, stockId: string }
            let newPrice: number = 0;
            if (!(serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN)) {
                switch (priceTypeCode) {
                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                    case IPriceTypeEnum.CUSTOMER_LATEST:
                        let { retData: { price } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                        newPrice = +price;
                        break;
                    //售价选择 最近销价 
                    case IPriceTypeEnum.RECENT:
                        newPrice = await findPoDetailPrice(stockId, ["lateSalePrice", "retailPrice"], true)
                        break;
                    //售价选择 零售价
                    case IPriceTypeEnum.RETAIL:
                        newPrice = await findPoDetailPrice(stockId, ["retailPrice"])
                        break;
                    //售价选择 采购成本价
                    case IPriceTypeEnum.PUR_COST:
                        newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)
                        break;
                    //售价选择 档案进价
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = await findPoDetailPrice(stockId, ["purchasePrice"])
                        break;
                    //售价选择 石油价格
                    case IPriceTypeEnum.PETROLEUM:
                        newPrice = await findPoDetailPrice(stockId, ["petroleumPrice", "purchasePrice"], true);
                        break;
                }
            } else {
                newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)// latestPurPrice ?? purchasePrice
            }

            return {
                ...item,
                num: serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num) : +formatNum(num),
                price: newPrice,
                materialAmount: serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num * newPrice) : +formatNum(num * newPrice),
                receivableAmount: serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((num * newPrice * discountRate) / 100 - decreaseAmount) : +formatNum((num * newPrice * discountRate) / 100 - decreaseAmount),
                discountedAmount: serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((num * newPrice * discountRate) / 100) : +formatNum((num * newPrice * discountRate) / 100)
            }
        }))
        // console.log(newDetailsList)
        mode === "add" ? setDetailMaterialAddList(newDetailsList) : setDetailMaterialEditList(newDetailsList);
    }
    //根据销售类型，售价选择去查询采购明细对应的单价
    const findPoDetailPrice = async (stockId: string, priceType: string[], priceTypeLen?: boolean) => {
        let resultPrice: number = 0;
        await stockStatisticService.findId(stockId).then(async res => {
            let retData = await res.retData;
            resultPrice = priceTypeLen ? retData?.[priceType[0]] ?? retData?.[priceType[1]] : retData?.[priceType[0]];

        })
        return resultPrice
    }
    //服务地点
    const serviceLocationChange = (value: string, option: ISelectOption) => {
        option && onChange({ serviceLocationName: option.label, serviceLocationCode: option.value });
    }
    useEffect(() => {
        let { customerCode } = mode === "add" ? detailAddForm : detailEditForm as { customerCode: string }
        getVehicleAllList({ customerCode })
    }, [mode])

    const getVehicleAllList = async (param?: IVehicleFields) => {
        let params = {
            ...param,
            shopId,
            pageSize: 2000,
            pageNum: 1
        }
        const { retData } = await vehicleService.pages(params)
        const { records } = retData
        if (records.length === 0) { globalPrompt("message", { text: "该客户下没有车辆，点击左侧车辆牌照去新增吧!", type: "warning" }) }
        let newRecords = records.map(item => {
            return {
                ...item,
                label: item.licensePlate,
                value: item.licensePlate
            }
        })
        mode === "add" ? setVehicleAddAll(newRecords) : setVehicleEditAll(newRecords)
    }
    //客户名称
    const customerChange = (value: string, option: ISelectOption) => {
        if (value && option) {
            let { contact, phone, address, categoryCode, categoryName } = getFindItem(value, CustomerData)
            option && onChange({
                customerName: option.label,
                customerCode: option.value,
                contact,
                phone,
                customerAddress: address,
                customerTypeCode: categoryCode,
                customerTypeName: categoryName,
                licensePlate: null,
                vehicleTypeCode: null,
                vehicleTypeName: null,
                vehicleModel: null,
                vin: null
            });
        }
        getVehicleAllList({ customerCode: option?.value as string })
    }
    //车辆牌照
    const vehicleChange = (value: string, option: ISelectOption) => {
        let VehicleIList: any = mode === "add" ? vehicleAddAll : vehicleEditAll
        if (value && option) {
            let { customerName, customerCode, licensePlate, categoryCode, categoryName, phone, contact, address, vin, typeCode, typeName, model } = getVehicleItem(value, VehicleIList)
            option && onChange({
                customerName,
                customerCode,
                contact,
                phone,
                customerAddress: address,
                vin,
                licensePlate,
                vehicleTypeCode: categoryCode,
                vehicleTypeName: categoryName,
                vehicleModel: model,
                customerTypeCode: typeCode,
                customerTypeName: typeName,
            });
        }
    }
    //vin码
    const vinChange = (value: string, option: ISelectOption) => {
        let VehicleIList: any = mode === "add" ? vehicleAddAll : vehicleEditAll
        if (value && option) {

            let { customerName, customerCode, licensePlate, brandCode, brandName, categoryCode, categoryName, phone, contact, address, vin, typeCode, typeName, model } = getVinItem(value, VehicleIList)
            option && onChange({
                //customerName,
                customerCode,
                contact,
                phone,
                customerAddress: address,
                vin,
                licensePlate,
                vehicleTypeCode: categoryCode,
                vehicleTypeName: categoryName,
                vehicleModel: model,
                customerTypeCode: typeCode,
                customerTypeName: typeName,
            });
        }
    }
    const typeForm = {
        add: { ...detailAddForm, shopId, shopCode, shopName },
        edit: detailEditForm,
        look: detailLookForm
    }
    const goCustomer = () => {
        replaceNav(
            selectedNavId,
            "13-5-1-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    const goVehicle = () => {
        replaceNav(
            selectedNavId,
            "13-5-2-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id,
                    customerCode: typeForm[mode].customerCode
                }
            },
            true)
    }

    const onConsumption = () => {
        let { customerCode, customerName } = typeForm[mode]
        if (!customerCode) {
            return message.warning("请先选择客户")
        }
        setConsumeHistoryVisible(true)
        setConsumeHistoryModel({ customerName: customerName as string })
    }
    const onRepairHistory = () => {
        let { licensePlate } = typeForm[mode]
        if (!licensePlate) {
            return message.warning("请先选择车辆")
        }
        setRepairHistoryVisible(true)
        setRepairHistoryModel({ licensePlate: licensePlate })
    }

    const title = <>
        <span>基础信息</span>
        <Tooltip placement="topLeft" title="消费记录">
            <FontIcon type="icon-xiaofeijilu" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onConsumption}
            />
        </Tooltip>
        <Tooltip placement="topLeft" title="维修历史">
            <FontIcon type="icon-ic_history" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onRepairHistory}
            />
        </Tooltip>
    </>
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        rightChildren,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "工单单号",
                fieldName: "maintenanceCode",
                disable: true,
                placeholder: "自动生成",
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="click-span" onClick={(e) => { e.stopPropagation(); goCustomer() }}>客户名称</span>,
                fieldName: "customerCode",
                options: transOptions(CustomerData),
                onSelectChange: customerChange,
                allowClear: true,
                showSearch: true,
                rules: [{ required: true, message: "请选择客户" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "送修人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入送修人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "送车电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入送车电话" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "维修类型",
                fieldName: "serviceNatureCode",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.REPAIR_TYPE),
                onSelectChange: serviceNatureChange,
                rules: [{ required: true, message: "请选择维修类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "售价选择",
                fieldName: "priceTypeCode",
                disable: true,
                options: getSelectedDictOne(DictCodeEnmu.PRICE_SELECTION),
                onSelectChange: priceTypeChange,
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="click-span" onClick={goVehicle}>车辆牌照</span>,
                fieldName: "licensePlate",
                allowClear: true,
                showSearch: true,
                options: mode === "add" ? vehicleOption(vehicleAddAll) : vehicleOption(vehicleEditAll),
                onSelectChange: vehicleChange,
                rules: [{ required: true, message: "请输入车牌号" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "VIN码",
                fieldName: "vin",
                allowClear: true,
                showSearch: true,
                onSelectChange: vinChange,
                options: mode === "add" ? vinOption(vehicleAddAll) : vinOption(vehicleEditAll),

            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售实体",
                fieldName: "bentityCode",
                options: beShopDs,
                allowClear: true,
                showSearch: true,
                onSelectChange: bentityChange,
                rules: [{ required: true, message: "请选择销售实体" }]

            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "结算方",
                fieldName: "settlementPartyCode",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_PARTY),
                onSelectChange: settlementPartyChange,
                rules: [{ required: true, message: "请选择结算方" }],
                hidden: mode === "look"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方",
                fieldName: "settlementPartyName",
                hidden: mode !== "look"
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "结算类型",
                fieldName: "payType",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
                rules: [{ required: true, message: "请选择结算类型" }],
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "整单抹零",
                fieldName: "favorableAmount",
                disable: true,
                span: 5,
                labelCol: { offset: 1 },
            }, {
                type: FormItemTypeEnum.Button,
                fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
                fieldName: "none",
                span: 1,
                labelCol: { offset: 5 },
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "车辆类型",
                fieldName: "vehicleTypeCode",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
                onSelectChange: vehicleTypeChange,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆型号",
                fieldName: "vehicleModel",
                hidden: more
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "发票类型",
                fieldName: "invoiceTypeCode",
                hidden: more,
                options: getSelectedDictOne(DictCodeEnmu.INVOICE_TYPE),
                onSelectChange: invoiceTypeChange,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆里程",
                fieldName: "mileage",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "工作小时",
                fieldName: "workingHours",
                hidden: more
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "进厂时间",
                showTime: true,
                fieldName: "enterTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "出厂时间",
                showTime: true,
                fieldName: "deliveryTime",
                hidden: more

            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "服务地点",
                fieldName: "serviceLocationCode",
                allowClear: true,
                showSearch: true,
                hidden: more,
                onSelectChange: serviceLocationChange,
                options: getSelectedDictOne(DictCodeEnmu.SERVICE_ADDRESS),
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属站点",
                fieldName: "shopName",
                disable: true,
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "故障描述",
                fieldName: "faultDesc",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "处理意见",
                fieldName: "faultResult",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户地址",
                fieldName: "customerAddress",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "待修内容",
                fieldName: "toBeRepaired",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "下次保养时间",
                fieldName: "nextMaintainTime",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "财务备注",
                fieldName: "fmsNote",
                hidden: more
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                hidden: more
            },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售实体名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆类型Name",
                fieldName: "vehicleTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修类型Name",
                fieldName: "maintenanceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方Name",
                fieldName: "settlementPartyName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方式Name",
                fieldName: "paymentMethodName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户类型Name",
                fieldName: "customerTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型Name",
                fieldName: "invoiceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "服务类型Name",
                fieldName: "serviceNatureName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "服务地点Name",
                fieldName: "serviceLocationName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "售价选择Name",
                fieldName: "priceTypeName",
                hidden: true
            }
        ]
    };

    const onChange = (changedValues: { [key: string]: any }) => {
        mode === "add" ? updateAddFormVal(changedValues) : updateEditFormVal(changedValues)
        setTopButsControl(true)
    }
    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        disabled: !isMaterialModel(),
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}